module.exports = __webpack_public_path__ + "img/voice-call.4e420a9f.svg";